import React from 'react';

interface OrbitingCirclesProps {
  className?: string;
  children?: React.ReactNode;
  reverse?: boolean;
  duration?: number;
  delay?: number;
  radius?: number;
  path?: boolean;
  iconSize?: number;
  speed?: number;
}

export default function OrbitingCircles({
  className = '',
  children,
  reverse = false,
  duration = 20,
  delay = 0,
  radius = 150,
  path = true,
  iconSize = 40,
  speed = 1,
}: OrbitingCirclesProps) {
  const calculatedDuration = duration / speed;
  const childArray = React.Children.toArray(children);

  return (
    <>
      {/* Orbit path circle */}
      {path && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="pointer-events-none absolute inset-0 w-full h-full"
          style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
          width={radius * 2 + iconSize}
          height={radius * 2 + iconSize}
        >
          <circle
            className="stroke-slate-200"
            cx="50%"
            cy="50%"
            r={radius}
            fill="none"
            strokeWidth="1"
            strokeDasharray="0"
          />
        </svg>
      )}

      {/* Orbiting items */}
      {childArray.map((child, index) => {
        const angle = (360 / childArray.length) * index;
        const itemDelay = (index * calculatedDuration) / childArray.length;

        return (
          <div
            key={index}
            className={`absolute ${className}`}
            style={{
              width: `${iconSize}px`,
              height: `${iconSize}px`,
              left: '50%',
              top: '50%',
              marginLeft: `-${iconSize / 2}px`,
              marginTop: `-${iconSize / 2}px`,
              animation: `${reverse ? 'orbit-reverse' : 'orbit'} ${calculatedDuration}s linear infinite`,
              animationDelay: `-${itemDelay}s`,
              // CSS custom properties for the keyframes
              ['--angle' as string]: angle,
              ['--radius' as string]: radius,
            }}
          >
            {/* Counter-rotate to keep icon upright */}
            <div
              className="flex items-center justify-center w-full h-full rounded-full bg-white shadow-lg border border-slate-100 p-2"
              style={{
                animation: `counter-rotate ${calculatedDuration}s linear infinite`,
                animationDelay: `-${itemDelay}s`,
                animationDirection: reverse ? 'reverse' : 'normal',
              }}
            >
              {child}
            </div>
          </div>
        );
      })}
    </>
  );
}
